import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {WebFormContainerComponent} from "../../../../common/components/web.form.container/web.form.container.component";
import {AppConfigurationService} from "../../../../common/app-config/app-configuration.service";

@Component({
  selector: 'app-patient-details',
  templateUrl: './patient.details.component.html',
  styleUrls: ['./patient.details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PatientDetailsComponent implements OnInit {
  @ViewChild('PatientDetailsForm', {static: false}) patientDetailsForm: WebFormContainerComponent;
  @Output() next = new EventEmitter();
  @Output() back = new EventEmitter();

  public patientDetailsURL: string;
  public patientDataValidated = false;
  public showForm = true;
  private nextFlag = false;
  private backFlag = false;

  public informationText1 = '';
  public informationText2 = '';
  public informationText3 = '';
  public informationActionTextIndex = 0;
  public informationAction: any;

  constructor(private changeDetector: ChangeDetectorRef,
              private appConfigService: AppConfigurationService) {
  }

  ngOnInit() {
    this.patientDetailsURL = this.appConfigService.Config.webForms.patientDetailsURL;

    this.informationText1 = 'HaveYouBeenHereBefore';
    this.informationText2 = 'GoBack';
    this.informationText3 = 'ToSearchAgainOrContactUS';
    this.informationActionTextIndex = 2;
    this.informationAction = this.goback;
  }

  public continue() {
    this.nextFlag = true;
    this.patientDetailsForm.getData();
  }

  public goback() {
    this.backFlag = true;
    this.patientDetailsForm.getData();
  }

  public setPatient(patient: any) {
    this.patientDetailsForm.setData(patient);
  }

  public reset() {
    this.showForm = false;
    this.changeDetector.markForCheck();
    setTimeout(() => {
      this.showForm = true;
      this.changeDetector.markForCheck();
    }, 10);
  }

  public dataValidated(valid: boolean) {
    this.patientDataValidated = valid;
    this.changeDetector.markForCheck();
  }

  public dataReceived(patient: any) {
    if (this.backFlag) {
      this.back.emit(patient);
    } else if (this.nextFlag) {
      this.next.emit(patient);
    }
    this.backFlag = false;
    this.nextFlag = false;
  }
}
